import React from 'react';
import { CountPerField as LanguageInfo } from '../statistics-response';
import DataTable, { LinkGenerator } from 'components/static-data-grid/data-table';
import { OnLinkClick } from 'components/buttons/link';
import { getResourcePath } from 'admin/pages-factory';


const heads = [
  {
    id: 'id',
    label: `Language`
  },
  {
    id: 'count',
    label: `Clients`,
    isNumeric: true
  },
  {
    id: 'precentage',
    label: `Clients, %`,
    isNumeric: true
  }
]


interface Props {
  resource: Array<LanguageInfo>;
  filter?: Record<string, any>;
  onLink: OnLinkClick;
}

const LanguagesTable: React.FC<Props> = props => {
  const linkGenerator: LinkGenerator = (id: string) => {
    return {
        redirectTo: 'list',
        pathTo: getResourcePath('/clients'),
        filter: {language: id, ...props.filter}
      };
    }

  return <DataTable
            resource={props.resource}
            heads={heads}
            sortBy='count'
            linkGenerator={linkGenerator}
            onLink={props.onLink} />
}

export default LanguagesTable;